const BASELINE_VIEW = "base";
const WORKSPACE_VIEW = "workspace";
const CONTEXT_BASELINE = "baseline";
const CONTEXT_WORKSPACE = "workspace";

module.exports = { BASELINE_VIEW, WORKSPACE_VIEW, CONTEXT_BASELINE, CONTEXT_WORKSPACE };
